import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
import * as moment from 'moment-timezone'

Vue.use(Vuex)

export default ({
  state: {
    loadedEquipments: []
  },
  mutations: {
    createEquipmentNumber (state, payload) {
      const equipment = state.loadedEquipments.find(equipment => {
        return equipment.id === payload.id
      })
      if (payload.type) {
        equipment.type = payload.type
      }
      if (payload.name) {
        equipment.name = payload.name
      }
      if (payload.model) {
        equipment.model = payload.model
      }
    },
    createEquipment (state, payload) {
      state.loadedEquipments.push(payload)
    },
    setLoadedEquipments (state, payload) {
      state.loadedEquipments = payload
    },
    deleteEquipment (state, payload) {
      for (var i = 0; i < state.loadedEquipments.length; i++) {
        if (state.loadedEquipments[i].id === payload) {
          state.loadedEquipments.splice(i, 1)
        }
      }
    },
    returnEquipment (state, payload) {
      const event = state.loadedEquipments.find(event => {
        return event.id === payload.id
      })
      if (payload.name) {
        event.name = payload.name
      }
      if (payload.quantity) {
        event.quantity = payload.quantity
      }
      if (payload.currentQuantity) {
        var newArray = payload.quantity.push(payload.currentQuantity + payload.number)
        event.currentQuantity = newArray
      }
      if (payload.model) {
        event.model = payload.model
      }
      if (payload.imageUrl) {
        event.imageUrl = payload.imageUrl
      }
      if (payload.date) {
        var newarray = payload.date.push(moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[0] + ' ' + moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[1].split('+')[0])
        event.date = newarray
      }
    },
    loanEquipment (state, payload) {
      const event = state.loadedEquipments.find(event => {
        return event.id === payload.id
      })
      if (payload.name) {
        event.name = payload.name
      }
      if (payload.quantity) {
        event.quantity = payload.quantity
      }
      if (payload.currentQuantity) {
        var newArray = payload.quantity.push(payload.currentQuantity - payload.number)
        event.currentQuantity = newArray
      }
      if (payload.model) {
        event.model = payload.model
      }
      if (payload.imageUrl) {
        event.imageUrl = payload.imageUrl
      }
      if (payload.date) {
        var newarray = payload.date.push(moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[0] + ' ' + moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[1].split('+')[0])
        event.date = newarray
      }
    }
  },
  actions: {
    createEquipmentNumber ({ commit }, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.quantity) {
        updateObj.quantity = payload.quantity
      }
      if (payload.name) {
        updateObj.name = payload.name
      }
      if (payload.model) {
        updateObj.model = payload.model
      }
      firebase.database().ref('/equipment/').child(payload.id).update(updateObj)
        .then(() => {
          commit('setLoading', false)
          commit('createEquipment', payload)
        })
        .catch(error => {
          console.log(error)
          commit('setLoading', false)
        })
    },
    createEquipment ({ commit }, payload) {
      const equipment = {
        name: payload.name,
        quantity: [payload.quantity],
        model: payload.model,
        date: payload.date
      }
      let imageUrl
      let key
      firebase.database().ref('equipment').push(equipment)
        .then((data) => {
          const key = data.key
          return key
        })
        .then(key => {
          const filename = payload.image.name
          const ext = filename.slice(filename.lastIndexOf('.'))
          firebase.storage().ref('equipment/' + key + ext).put(payload.image)
            .then(() => {
              return firebase.storage().ref('equipment/' + key + ext).getDownloadURL()
                .then((url) => {
                  firebase.database().ref('equipment').child(key).update({ imageUrl: url })
                })
            })
        })
        .then(() => {
          commit('createEquipment', { ...equipment, id: key, imageUrl: imageUrl })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    loadEquipments ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('equipment').once('value')
        .then((data) => {
          const equipments = []
          const obj = data.val()
          for (const key in obj) {
            equipments.push({
              id: key,
              name: obj[key].name,
              quantity: obj[key].quantity,
              currentQuantity: obj[key].quantity.pop(),
              model: obj[key].model,
              imageUrl: obj[key].imageUrl,
              date: obj[key].date
            })
          }
          commit('setLoading', false)
          commit('setLoadedEquipments', equipments)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    deleteEquipment ({ commit }, payload) {
      firebase.database().ref('equipment').child(payload).remove()
      commit('deleteEquipment', payload)
    },
    returnEquipment ({ commit }, payload) {
      commit('setLoading', true)
      firebase.database().ref('equipment').child(payload.id).once('value')
        .then((data) => {
          var data1 = data.val()
          data1.date.push(moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[0] + ' ' + moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[1].split('+')[0])
          var position = data1.quantity.length
          var last = data1.quantity[position - 1]
          data1.quantity.push(last + payload.number)
          firebase.database().ref('equipment').child(payload.id).update(data1)
            .then(() => {
              commit('setLoading', false)
              commit('returnEquipment', payload)
            })
            .catch(error => {
              console.log(error)
              commit('setLoading', false)
            })
        })
    },
    loanEquipment ({ commit }, payload) {
      commit('setLoading', true)
      firebase.database().ref('equipment').child(payload.id).once('value')
        .then((data) => {
          var data1 = data.val()
          data1.date.push(moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[0] + ' ' + moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format().split('T')[1].split('+')[0])
          var position = data1.quantity.length
          var last = data1.quantity[position - 1]
          data1.quantity.push(last - payload.number)
          firebase.database().ref('equipment').child(payload.id).update(data1)
            .then(() => {
              commit('setLoading', false)
              commit('returnEquipment', payload)
            })
            .catch(error => {
              console.log(error)
              commit('setLoading', false)
            })
        })
    }
  },
  getters: {
    loadedEquipments (state) {
      return state.loadedEquipments.sort((EquipmentA, EquipmentB) => {
        return EquipmentA.name > EquipmentB.name
      })
    },
    loadedEquipment (state) {
      return (EquipmentId) => {
        return state.loadedEquipments.find((Equipment) => {
          return Equipment.id === EquipmentId
        })
      }
    }
  }
})
